/**
 * @name 向wa上报统计内容
 * 同时引入旧打点库，兼容 public/js/portal; data-statis属性的统计上报
 *
 * @constructor 构造函数将绑定所有具有以下特征的元素，然后在元素被操作后将其上的对应属性内容上报。
 *              元素上可绑定report-to属性，属性作用同下reportTo参数.
 *
 * 注意:打点信息中action必传
 * @绑定在dom的点击上报
 * @example 1 => <div data-stat(data-portal-stat)="action:action;XXX:XXX;XXX2:XXX2;"></div> <可自定义属性内容，推荐使用>
 * @example 2 => <div data-stat="true" data-action="XXX" data-a1 data-a2 data-a3 data-a4 data-an ></div>
 *
 * @绑定在dom的曝光上报
 * @example 1 => <div data-explore(data-portal-explore)="action:action;XXX:XXX;XXX2:XXX2;"></div>
 *
 * @method Stat 上报到wa event报表
 * @param {action:'',a1:'',a2:''...} 该对象内的属性内容都将上报(可自定义)。
 *
 * @method StatPortal 上报到wa 门户portal表，并经过清洗后进入门户清洗中间表
 * @param {ag_action:'',ag_a1:'',ag_a2:''...} 将属性上报到门户的发行统计接口 ad/report。
 */
require('public/portal');
const MobileDetect = require('public/mobile-detect');
const count = require('public/count');
count.init();
class stat {
  constructor() {
    this.scrollListener = $(window);
    this.md = new MobileDetect(window.navigator.userAgent);
    this.ExploreEleMap = {};
    this.ExplorePortalEleMap = {};
    this.initBindElementClick();
    this.initBindElementExplore();
    this.url = this._url;
    this.nt = this._nt;
    this.app = this._app;
    this.uuid = this._uuid;
    this.ver = this._ver;
    this.referer = this._referer;
    this.system = this._system;
    this.pg = this._pg;
    this.pathname = window.location.pathname;
    this.sendPortalAdUrl = '/stat/ad/report/';
  }
  set scrollDOM($DOM) {
    this.scrollListener = typeof $DOM === 'string' ? $($DOM) : $DOM;
    this.bindScrollEvent();
  }
  // js曝光上报
  Explore($DOM, statInfo) {
    const $dom = typeof $DOM === 'string' ? $($DOM) : $DOM;
    $dom.attr('data-explore', JSON.stringify(statInfo).replace(/,/g, ';').replace('{', '').replace('}', '').replace(/"/g, ''));
  }
  // js曝光上报到门户
  ExplorePortal($DOM, statInfo) {
    const $dom = typeof $DOM === 'string' ? $($DOM) : $DOM;
    $dom.attr('data-portal-explore', JSON.stringify(statInfo).replace(/,/g, ';').replace('{', '').replace('}', '').replace(/"/g, ''));
  }

  Stat(statInfo) {
    if (!statInfo.action) return;
    statInfo.uuid = this.uuid;
    statInfo.lt = statInfo.lt || "event";
    statInfo.biz = statInfo.biz || "ngm_portal";
    statInfo.link = this.url;
    statInfo.pg = statInfo.pg || this.pg;
    statInfo.app = statInfo.app || this.app;
    statInfo.nt = statInfo.nt || this.nt;
    statInfo.ver = statInfo.ver || this.ver;
    statInfo.pathname = this.pathname;
    statInfo.referer = statInfo.referer || this.referer;
    statInfo.system = statInfo.system || this.system;

    this.Send(statInfo);
  }

  StatPortal(statInfo) {
    if (!statInfo.ac) {
      statInfo.ac = "recsys_show";
    }
    this.SendToPortal(statInfo);
  }
  // 门户要求，抛九游包需要跑一下这个打点统计
  StatHightSpeedDownload(gameId) {
    const pid = this.app === 'pc' ? 10 : 2;
    const statisU = `https://a.9game.cn/highspeed.html?gid=${gameId || 0}&pid=${pid}&outurl=https://www.9game.cn/public/images/android_portal/link/logo.png`;
    let statis = new Image(), sUrl = statisU + "&r=" + Math.random();
    if (typeof text != "undefined") {
      sUrl += "&" + text.replace(":", "=");
    }
    statis.src = sUrl;
    statis.onload = statis.onerror = function () {
    }
  }

  get _system() {
    return this.md.os() || 'unknown';
  }

  get _referer() {
    return '';
  }

  get _pg() {
    return location.pathname.toLowerCase().replace(/^\//, '').replace(/\//g, '_') || '/';
  }

  get _ver() {
    return (this.md.version('Android') || undefined);
  }

  get _url() {
    return encodeURIComponent(location.href || document.URL);
  }

  get _nt() {
    return window.navigator.connection ? window.navigator.connection.type || 'pc' : 'pc';
  }

  get _uuid() {
    const sid = this.getCookie('sid');
    return sid;
  }

  get _app() {
    return this.md.phone() || 'pc';
  }

  copyObject(obj) {
    const result = {};
    for (const i in obj) {
      if (obj.hasOwnProperty(i)) {
        result[ i ] = obj[ i ];
      }
    }
    return result;
  }

  getCookie(c_name) {
    const that = this;
    let c_start, c_end;
    if (document.cookie.length > 0) {
      c_start = document.cookie.indexOf(c_name + '=');
      if (c_start !== -1) {
        c_start = c_start + c_name.length + 1;
        c_end = document.cookie.indexOf(';', c_start);
        if (c_end === -1) {
          c_end = document.cookie.length;
        }
        return unescape(document.cookie.substring(c_start, c_end));
      }
    }
    return '';
  }

  getElementTop(element) {
    var actualTop = element.offsetTop;
    var current = element.offsetParent;

    while (current !== null) {
      actualTop += current.offsetTop;
      current = current.offsetParent;
    }

    return actualTop;
  }
  doExplore() {
    const winHeight = window.innerHeight + this.scrollListener.scrollTop();
    const deleteIndex = [];
    const deletePortalIndex = [];
    for (const i in this.ExploreEleMap) {
      if (this.ExploreEleMap[ i ].height < winHeight) {
        deleteIndex.push(i);
        this.Stat(this.ExploreEleMap[ i ].stat);
      }
    }
    for (const i in this.ExplorePortalEleMap) {
      if (this.ExplorePortalEleMap[ i ].height < winHeight) {
        deletePortalIndex.push(i);
        this.StatPortal(this.ExplorePortalEleMap[ i ].stat);
      }
    }
    deletePortalIndex.forEach(e => {
      delete this.ExplorePortalEleMap[ e ];
    })
    deleteIndex.forEach(e => {
      delete this.ExploreEleMap[ e ];
    })
  }

  initBindElementExplore() {
    window.setTimeout(() => {
      $('[data-explore]').each((index, e) => {
        const array = $(e).data('explore').split(';');
        const stat = {};
        array.forEach(element => {
          const tempInfo = element.split(':');
          stat[ tempInfo[ 0 ] ] = tempInfo[ 1 ];
        });
        this.ExploreEleMap[ index ] = { stat, height: this.getElementTop(e) };
      });
      $('[data-portal-explore]').each((index, e) => {
        const array = $(e).data('portalExplore').split(';');
        const reportTo = $(e).attr('report-to') || 'ad';
        const stat = {};
        array.forEach(element => {
          const tempInfo = element.split(':');
          stat[ tempInfo[ 0 ] ] = tempInfo[ 1 ];
        });
        this.ExplorePortalEleMap[ index ] = { stat, height: this.getElementTop(e), reportTo };
      });
      this.doExplore();
      this.bindScrollEvent();
    }, 1000);
  }

  bindScrollEvent() {
    this.scrollListener.on('scroll', e => {
      this.doExplore();
    }, false);
  }

  initBindElementClick() {
    window.setTimeout(() => {
      $('[data-stat]').each((index, e) => {
        $(e).on('click', e => {
          const statInfo = $(e.target).data('stat');
          if (!statInfo) return;
          if (statInfo === 'true') {
            const statStatus = [ 'action', 'a1', 'a2', 'a3', 'a4', 'an' ];
            let statInfo = {};
            statStatus.forEach(element => {
              $(e.target).data(`${element}`) ? statInfo[ element ] = $(e.target).data(`${element}`) : '';
            });
            this.Stat(statInfo);
          } else {
            const array = statInfo.split(';');
            const stat = {};
            array.forEach(element => {
              const tempInfo = element.split(':');
              stat[ tempInfo[ 0 ] ] = tempInfo[ 1 ];
            });
            this.Stat(stat);
          }
        });
      }, true);

      $('[data-portal-stat]').each((i, e) => {
        const self = this;
        $(e).on('click', function () {
          const statInfo = $(this).attr('data-portal-stat');
          if (!statInfo) return;
          const array = statInfo.split(';');
          const stat = {};
          array.forEach(element => {
            const tempInfo = element.split(':');
            stat[ tempInfo[ 0 ] ] = tempInfo[ 1 ];
          });
          self.StatPortal(stat);
        });
      }, false);
    }, 0);
  }

  ReCode(c, prefix) {
    const n = Object.keys(c);
    let a = [];
    n.forEach(function (n) {
      if (c[ n ]) {
        if (prefix) {
          a.push(prefix + '_' + n + '=' + c[ n ]);
        } else {
          a.push(n + '=' + c[ n ]);
        }
      }
    });
    return a.join('&');
  };

  IsSpider() {
    return !!window.navigator.userAgent.toLowerCase().match('spider') || !!window.navigator.userAgent.toLowerCase().match('bot');
  }

  Send(stat) {
    if (this.IsSpider()) return;
    window.setTimeout(() => {
      const url = '//track.uc.cn/collect?appid=28c809c8fbb2';
      const strStat = this.ReCode(stat);
      try {
        new Image().src = [ url, strStat ].join('&');
      } catch (e) {
        console.log('>>>>> report error');
      }
    }, 0);
  }

  SendToPortal(stat) {
    if (this.IsSpider()) return;
    if (typeof $ === 'undefined') {
      console.warn('[SendToPortal]:缺少"$"依赖,ajax上报门户失败');
      return;
    }

    const statArr = [];
    const statResult = {};
    for (const i in stat) {
      if (i !== 'ac') {
        statArr.push(`${i}\\=${stat[ i ]}`);
      }
    }
    statResult.ac = stat.ac;
    statResult.diyParams = statArr.join('`');
    window.setTimeout(() => {
      $.ajax({
        type: 'POST',
        url: this.sendPortalAdUrl,
        data: statResult,
        timeout: 4000,
        success: function (data) {
        },
        error: function (err) {
        }
      });
    }, 0);
  }

}
if (window.GLOBAL_stat) {
  module.exports = window.GLOBAL_stat;
} else {
  module.exports = window.GLOBAL_stat = new stat();
}


// WEBPACK FOOTER //
// ./lib/js/public/stat.js